import { Component, Vue, Watch } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { Customer, Project } from './interface'
import { getDepartmentByUserId } from '@/api/common'
import { formatDate } from '@/utils/timeFilter'
import { getCustomerList, getProjectList, getMarketCooperationCommissionTypeByMarketCooperationIdAndProjectAllId, setFinanceOrder, getFinanceOrderById, setFinanceOrderById,getCompanyList } from '@/api/financial-center'
import { getDraftById, setDraftById } from '@/api/draft'
import { delNullProperty } from '@/utils/index'
import Login from "@/views/login/login";
import * as math from 'mathjs'

@Component({
    filters: {
        commissionType: (val: string) => {
            let str = ''
            switch (val) {
                case '0':
                    str = '暂无'
                    break;
                case '1':
                    str = '结算价'
                    break;
                case '2':
                    str = '返点'
                    break;
                default:
                    str = ''
                    break;
            }
            return str
        }
    }
})
export default class NewOridinary extends Vue {
    orderAllNum = 0 //业绩比例
    isPatioShow = false //是否显示业绩
    timeBegin = ''
    radioDisable = false
    radioOptions = []
    radioProject = ''
    disabledButton = false
    isDraft = '0'
    orderId: number = null
    draftId: number = null
    changeData = false
    errorDialogShow = false
    projectDialogShow = false
    dialogProjectInputValue = ''
    projectDialogTableData = []
    projectDialogCheckedTable: Project = {
        souTeacherName: '',
        souTeacherSchool: '', // 导师学校
        projectAllId: null,
        souCourseIndex: '',
        souCourseName: '',
        souCoursePrice: '',
        souCourseSchoolBegin: '',
        souCourseType: '',
        status: '',
        surplusQuota: null,
        radio: '0', //是否展示双课题备注
        doubleSouCourseName: '', //双课题备注
        souCourseNameTwo: '' , // 专业选修课
    }
    projectDialogTableLoading = false
    dialogProjectPage = 1
    dialogProjectTotal = 0
    dialogProjectLimit = 20

    saveDraftDialogShow = false

    // performanceRatio = '' // 业绩比例分配
    formModel = {
        souTeacherName:'', //导师名字
        souTeacherSchool:'', //导师学校
        priceOrRatio: 0, // 结算价
        customerName: '', // 客户名称
        project: '', // 意向项目
        settlementPrice: '', // 结算价
        thisRebateRatio: '', // 返点比例
        discountAmount: 0, // 优惠金额
        sellingPrice: 0, // 合计金额
        isIPQ: '0', // IPQ辅导服务
        isCredit:'无',  //美高学分
        dissertationType: '', // 论文服务类型
        remark: '', // 备注
        runesName: '', // 送生顾问
        directorUserId: '', // 负责人
        cooperationUserId: '', // 合作成单同事
        achievementRatio: '', // 业绩比例分配
        teacherUserId: '',
        thesisUserId:  '',
        helperUserId:  '',
        productUserId:  '',  //产品负责人
        department: '', // 部门
        createUserName: '', // 创建人
        createAt: new Date(),
        isDoubleSouCourseName: '0',
        projectAllId: '',
        souCoursePrice: '',
        companyName:'', //所属公司
        contractNo: '', // 合同编号
        egistrationForm: '',// 报名表
        performanceRatio: '' ,//业绩比例分配
        ipqSubject: '' ,//IEPQ学科方向
        scene: '' , //企业导师推荐信使用场景
    }
    oldFormData: any = null
    settlementPriceList = [] // 结算价数组，当有多个结算价的时候使用
    isUpdatedData = '' // 查看的是就数据还是新数据
    name: any = ''
    customerNameLimit = 20
    updateIsDoubleSouCourseName = '' // 编辑-后端返回的是否有双课题备注
    fileList = []
    previewVisible = false
    previewPath = ''
    previewName = ''
    IPQList = [
        '金融/金融工程',
        '经济学',
        '市场营销 （广告学，奢侈品管理）',
        'PPE（政经哲）',
        '酒店管理/旅游管理',
        '管理学',
        '人力资源管理',
        '体育管理',
        '会计学',
        '行为经济学',
        '心理学（教育心理，犯罪心理，体育心理）',
        '教育',
        '法学',
        '传媒（新闻，传播，文化传媒）',
        '历史',
        '国际关系',
        '性别研究',
        '社会学',
        '哲学（伦理学，逻辑学）',
        '公共政策管理',
        ' 语言学',
        '文学',
        '人类学/考古学',
        '建筑/电影/音乐/视觉艺术',
        '计算机（计算机科学，计算机工程）',
        '机械工程（流体力学）',
        '电子工程',
        '物理',
        '天文学',
        '应用数学（数据科学）',
        '数学',
        '生物（药学，医学，营养学，生物化学）',
        '公共卫生（生物统计）',
        '化学',
        '环境工程/环境科学',
        '土木工程',
        '地理/地质'
    ]
    sceneList = [
        '求职', '升学', '待定-开课前确认'
    ]

    companyList = []
    formRules = {
        customerName: [{ required: true, message: '请输入客户名称', trigger: 'change' }],
        project: [{ required: true, message: '请选择意向项目', trigger: 'change' }],
        companyName: [{ required: true, message: '请选择所属公司', trigger: 'change' }],
        settlementPrice: [{ required: true, message: '请输入结算价', trigger: 'blur' }],
        thisRebateRatio: [{ required: true, message: '请输入本单返点比例', trigger: 'change' }],
        directorUserId: [{ required: true, message: '请选择负责人', trigger: 'change' }],
        discountAmount: [{ validator: this.discountAmountRules, trigger: 'blur' }],
        dissertationType: [{ required: true, message: '请选择论文服务类型', trigger: 'change' }],
        achievementRatio: [{required: true, message: '请填写业绩比例分配', trigger: ['change', 'blur']}],
        performanceRatio: [{required: true, message: '请填写业绩比例分配', trigger: ['change', 'blur']}],
        scene: [{required: true, message: '请选择企业导师推荐信使用场景', trigger: ['change', 'blur']}]
    }

    customerListLoading = false
    companyListLoading = false //所属公司
    customerList: Customer[] = []
    customerInfo: Customer = {
        customerId: undefined,
        customerName: '',
        customerSource: '',
        customerSourceType: '',
        customerType: '',
        marketCooperationId: undefined
    }
    radio = '' //单选
    projectInfo = {

    }
    intentionProjectSelected = [] //选中的意向项目列表
    isShowRadio = true
    isChangeRadio = false
    // isReadonly = false
    timer = null

    get userName() {
        if(this.formModel.createUserName) return this.formModel.createUserName
        return UserModule.userName
    }

    get userId() {
        return UserModule.userId
    }
    get userList() {
        // this.formModel.directorUserId = UserModule.userId as string
        return UserModule.userList
    }

    get handletimeBegin() {
        let str = ''
        if(!this.timeBegin || this.timeBegin.length === 0) {
            str = ''
        } else {
            str = formatDate('yyyy-MM-dd', new Date(this.timeBegin[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.timeBegin[1]))
        }
        return str
    }

    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }

    created() {
        this.getCustomerList()
        this.getCompanyList() //所属公司列表
        if(this.$route.query.orderId) {
            this.orderId = Number(this.$route.query.orderId)
            this.isUpdatedData = this.$route.query.isUpdatedData as string || '0'
            this.getFinanceOrderById()
        }
        if(this.$route.query.draftId) {
            this.draftId = Number(this.$route.query.draftId)
            this.getDraftById()
        }
    }

    handlePreview(file) {
        if(file.response){
            this.previewPath = file.response.data.ossUrl
        }else{
            this.previewPath = file.url
        }

        this.previewName = file.name
        this.previewVisible = true
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }


    discountAmountRules(rule, value, callback) {
        if(this.customerInfo.marketCooperationId === 0) {
            if(this.projectDialogCheckedTable.souCoursePrice.includes('/')) {
                if(Number(value) > Number(this.projectDialogCheckedTable.souCoursePrice.split('/')[0])) {
                    callback(new Error('优惠金额不能大于项目终端售价'))
                    return
                }
            } else {
                if(Number(value) > Number(this.projectDialogCheckedTable.souCoursePrice)) {
                    callback(new Error('优惠金额不能大于项目终端售价'))
                    return
                }
            }
        } else {
            if(this.customerInfo.commissionType === '1') {
                if(Number(value) > Number(this.customerInfo.priceOrRatio)) {
                    callback(new Error('优惠金额不能大于结算价'))
                    return
                }
            } else {
                if(this.projectDialogCheckedTable.souCoursePrice.includes('/')) {
                    if(Number(value) > Number(this.projectDialogCheckedTable.souCoursePrice.split('/')[0])) {
                        callback(new Error('优惠金额不能大于项目终端售价'))
                        return
                    }
                } else {
                    if(Number(value) > Number(this.projectDialogCheckedTable.souCoursePrice)) {
                        callback(new Error('优惠金额不能大于项目终端售价'))
                        return
                    }
                }
            }
        }
        callback()
    }

    // 所属公司列表
    async getCompanyList() {
        const data: any = await getCompanyList()
        this.companyList = data.companyList
    }

    async getDraftById() {
        const res: any = await getDraftById(this.draftId)
        const data = res.result
        this.formModel.isCredit = data.isCredit   //美高学分
        this.formModel.dissertationType = data.dissertationType  //论文服务类型
        this.formModel.priceOrRatio = data.priceOrRatio  //结算价
        this.projectDialogCheckedTable.souCourseType = data.souCourseType
        this.projectDialogCheckedTable.souCourseSchoolBegin = data.souCourseSchoolBegin
        this.projectDialogCheckedTable.souCourseNameTwo = data.souCourseNameTwo
        this.customerInfo.commissionType = data.commissionType
        this.customerInfo.customerId = data.customerId
        this.customerInfo.customerName = data.customerName
        this.customerInfo.customerType = data.customerType
        this.customerInfo.customerSource = data.source
        this.customerInfo.customerSourceType = data.sourceType === '1' ? '合作伙伴' : '普通来源'
        this.customerInfo.marketCooperationId = data.marketCooperationId
        this.customerInfo.priceOrRatio = data.priceOrRatio
        this.formModel.thisRebateRatio = data.priceOrRatio
        this.formModel.customerName = data.customerName
        this.formModel.contractNo = data.contractNo
        this.formModel.egistrationForm = data.egistrationForm
        this.formModel.ipqSubject = data.ipqSubject
        this.formModel.scene = data.scene

        if (data.egistrationForm) {
            this.fileList.push({
                name: data.egistrationForm,
                url: data.egistrationForm
            })
        }
        this.formModel.companyName = data.companyName //所属公司
        this.formModel.souTeacherName = data.souTeacherName //导师名称
        this.formModel.souTeacherSchool = data.souTeacherSchool //导师学校
        this.formModel.directorUserId = data.financeOrderUser.createdUserId
        this.formModel.cooperationUserId = data.financeOrderUser.cooperationUserId  //草稿箱成单同事
        this.formModel.achievementRatio = data.achievementRatio?data.achievementRatio.split(':')[0]: null  //草稿箱业绩比例分配
        this.formModel.performanceRatio = data.achievementRatio?data.achievementRatio.split(':')[1]: 0
        if(data.financeOrderUser.cooperationUserId){
            this.isPatioShow = true
        }
        this.formModel.runesName = data.financeOrderUser.adviser
        this.formModel.createUserName = data.financeOrderUser.createdUserRealName
        this.formModel.department = data.financeOrderUser.directorDepartmentlName
        this.formModel.isIPQ = data.haveIPQ
        this.formModel.discountAmount = data.discountPrice
        this.formModel.sellingPrice = data.price
        this.customerInfo.ratioPrice = math.number(math.multiply(math.bignumber(data.price), math.divide(math.bignumber(data.priceOrRatio), 100))) //预计返佣金额
        // this.formModel.project = data.souCourseName
        data.isDoubleSouCourseName == '0' ? this.formModel.project = data.souCourseName : this.formModel.project = data.doubleSouCourseName
        this.formModel.projectAllId = data.projectAllId
        this.formModel.souCoursePrice = data.souCoursePrice
        this.formModel.createAt = data.createdAt
        this.formModel.remark = data.remark
        this.formModel.directorUserId = data.financeOrderUser.directorUserId

        // this.projectDialogCheckedTable.souCourseName = data.souCourseName
        // this.projectDialogCheckedTable.souCoursePrice = data.souCoursePrice
        // this.projectDialogCheckedTable.projectAllId = data.projectAllId
        // this.clickProjectDialogConfirmButton()
    }

    async getFinanceOrderById() {
        const res: any = await getFinanceOrderById({ id: this.orderId, isUpdatedData: this.isUpdatedData })
        const data = res.financeOrder
        this.oldFormData = data // 将旧数据那一份下来，用于对比是否改变 项目 或 金额
        this.customerInfo.commissionType = data.commissionType
        this.customerInfo.customerId = data.customerId
        this.customerInfo.customerName = data.customerName
        this.customerInfo.customerType = data.customerType
        this.customerInfo.customerSource = data.source
        this.customerInfo.customerSourceType = data.sourceType === '1' ? '合作伙伴' : '普通来源'
        this.customerInfo.marketCooperationId = data.marketCooperationId
        this.customerInfo.priceOrRatio = data.priceOrRatio
        this.formModel.priceOrRatio = data.priceOrRatio
        this.formModel.thisRebateRatio = data.priceOrRatio
        this.formModel.customerName = data.customerName
        this.formModel.souTeacherName = data.souTeacherName //导师名称
        this.formModel.souTeacherSchool = data.souTeacherSchool //导师学校
        this.formModel.directorUserId = data.financeOrderUser.directorUserId
        this.formModel.cooperationUserId = data.financeOrderUser.cooperationUserId  //详情成单同事
        this.formModel.achievementRatio = data.achievementRatio?data.achievementRatio.split(':')[0]:null  //业绩分配比例
        this.formModel.performanceRatio = data.achievementRatio?data.achievementRatio.split(':')[1]:null
        this.formModel.companyName = data.companyName
        this.formModel.contractNo = data.contractNo
        this.formModel.egistrationForm = data.egistrationForm
        this.formModel.ipqSubject = data.ipqSubject
        this.formModel.scene = data.scene

        if (data.egistrationForm) {
            this.fileList.push({
                name: data.egistrationForm,
                url: data.egistrationForm
            })
        }
        if(data.financeOrderUser.cooperationUserId){
            this.isPatioShow = true
        }
        this.formModel.teacherUserId = data.projectTeacherUserRealName
        this.formModel.thesisUserId = data.projectThesisUserRealName
        this.formModel.helperUserId = data.projectHelperUserRealName
        this.formModel.productUserId = data.projectProductUserRealName
        this.formModel.runesName = data.financeOrderUser.adviser
        this.formModel.createUserName = data.financeOrderUser.createdUserRealName
        this.formModel.department = data.financeOrderUser.directorDepartmentlName

        this.formModel.isIPQ = data.haveIPQ
        this.formModel.isCredit = data.isCredit   //美高学分
        this.formModel.dissertationType = data.dissertationType  //论文服务类型
        this.formModel.discountAmount = data.discountPrice
        this.formModel.sellingPrice = data.price //订单金额合计
        this.customerInfo.ratioPrice = math.number(math.multiply(math.bignumber(data.price), math.divide(math.bignumber(data.priceOrRatio), 100))) //预计返佣金额

        // 判断是否有双课题备注
        // this.formModel.project = data.souCourseName
        data.isDoubleSouCourseName == '0' ? this.formModel.project = data.souCourseName : this.formModel.project = data.doubleSouCourseName
        this.formModel.isDoubleSouCourseName = data.isDoubleSouCourseName
        this.formModel.projectAllId = data.projectAllId
        this.formModel.souCoursePrice = data.souCoursePrice
        this.formModel.createAt = data.createdAt
        this.formModel.remark = data.remark
        this.projectDialogCheckedTable.souCourseType = data.souCourseType
        this.projectDialogCheckedTable.souCourseSchoolBegin = data.souCourseSchoolBegin

        this.projectDialogCheckedTable.souCourseName = data.souCourseName
        this.projectDialogCheckedTable.souCoursePrice = data.souCoursePrice
        this.radioProject = data.souCoursePrice
        this.projectDialogCheckedTable.projectAllId = data.projectAllId
        this.projectDialogCheckedTable.souCourseNameTwo = data.souCourseNameTwo
        // this.clickProjectDialogConfirmButton()
    }
    /*限制只能上传一个*/
    // uploadExceed(files, fileList) {
    //     console.log('fileList-------',fileList)
    //     console.log('files-------',files)
    //     this.$set(fileList[0], 'raw', files[0]);
    //     this.$set(fileList[0], 'name', files[0].name);
    //     (this.$refs['upload'] as HTMLFormElement).clearFiles();//清除文件
    //     (this.$refs['upload'] as HTMLFormElement).handleStart(files[0]);//选择文件后的赋值方法
    // }

    async getCustomerList() {
        const data: any = await getCustomerList({limit: this.customerNameLimit, customerName: this.name})
        this.customerList = [...this.customerList, ...data.customerList]
        let result = []
        let obj = {}
        for (let i = 0; i < this.customerList.length; i++) {
            if (!obj[this.customerList[i].customerId]) {
                result.push(this.customerList[i]);
                obj[this.customerList[i].customerId] = true;
            }
        }
        this.customerList = result
    }

    clearCustomer() {
        // this.formModel.customerId = null
        this.formModel.customerName = ''
        this.name = ''
        this.customerNameLimit = 20
        this.getCustomerList()
    }

    clearCustomerList(e) {
        if (!this.formModel.customerName) {
            this.name = ''
            this.customerNameLimit = 20
            this.getCustomerList()
        }
    }

    loadmore() {
        this.customerNameLimit += 20;
        this.getCustomerList();
    }

    async remoteMethod(query: any) {
        this.name = query
        this.customerNameLimit = 20
        if (query !== '') {
            const result: any = await getCustomerList({limit: this.customerNameLimit, customerName: this.name})
            this.customerList = result.customerList
        } else {
              this.customerList = []
            this.getCustomerList();
        }
    }

    customerChange(val) {
        this.formModel.customerName = val.customerName
        this.formModel.runesName = val.customerAdviser ? val.customerAdviser : ''
        // this.formModel.customerId = this.customerList.find(item => item.customerName === val.customerName).customerId
        if (val) {
            this.customerInfo = this.customerList.filter(item => (item.customerId === val.customerId && item.customerType === val.customerType))[0]
        } else {
            this.customerInfo = {
                customerId: undefined,
                customerName: '',
                customerSource: '',
                customerSourceType: '',
                customerType: '',
                marketCooperationId: undefined
            }
        }
        //    清空意向项目
        this.formModel.project = ''
        this.formModel.projectAllId = ''

        this.projectDialogCheckedTable = {
            souTeacherName: '',
            souTeacherSchool: '', // 导师学校
            projectAllId: null,
            souCourseIndex: '',
            souCourseName: '',
            souCoursePrice: '',
            souCourseSchoolBegin: '',
            souCourseType: '',
            status: '',
            surplusQuota: null,
            radio: '0', //是否展示双课题备注
            doubleSouCourseName: '', //双课题备注
            souCourseNameTwo: ''
        }
        this.formModel.souCoursePrice = '' // 项目终端售价
        this.formModel.souTeacherName = '' // 导师名称
        this.formModel.souTeacherSchool = '' // 导师学校
        this.formModel.sellingPrice = 0 // 订单金额合计

    }
    // 所属公司列表
    async getFoucsCompanyList() {
        if (this.customerList.length == 0 && !this.formModel.customerName) {
            this.name = ''
            this.customerNameLimit = 20
            const result: any = await getCustomerList({limit: this.customerNameLimit, customerName: this.name})
            this.customerList = result.customerList
        }
        if (this.formModel.customerName) {
            this.customerList = []
            this.customerNameLimit = 20
            const result: any = await getCustomerList({
                limit: this.customerNameLimit,
                customerName: this.formModel.customerName
            })
            this.customerList = result.customerList
        }
    }
    clearCompanyList(e) {
        if (!this.formModel.customerName) {
            this.name = ''
            this.customerNameLimit = 20
            this.getCustomerList()
        }
    }
    handleBlurList(e) {
        if (!this.formModel.customerName) {
            this.name = ''
            this.customerNameLimit = 20
            this.getCustomerList()
        }
    }
    async remoteCompanyMethod(query: any) {
        this.name = query
        this.customerNameLimit = 20
        if (query !== '') {
            const result: any = await getCustomerList({limit: this.customerNameLimit, customerName: this.name})
            this.customerList = result.customerList
        } else {
            //   this.customerList = []
        }
    }
    handleCompanyChange(val) {
        this.formModel.customerName = val.customerName
        // this.formModel.customerId = this.customerList.find(item => item.customerName === val.customerName).customerId
        if (val) {
            this.customerInfo = this.customerList.filter(item => (item.customerId === val.customerId && item.customerType === val.customerType))[0]
        } else {
            this.customerInfo = {
                customerId: undefined,
                customerName: '',
                customerSource: '',
                customerSourceType: '',
                customerType: '',
                marketCooperationId: undefined
            }
        }
    }
    async getFoucsCustomerList() {
        if (this.customerList.length == 0 && !this.formModel.customerName) {
            this.name = ''
            this.customerNameLimit = 20
            const result: any = await getCustomerList({limit: this.customerNameLimit, customerName: this.name})
            this.customerList = result.customerList
        }
        if (this.formModel.customerName) {
            this.customerList = []
            this.customerNameLimit = 20
            const result: any = await getCustomerList({
                limit: this.customerNameLimit,
                customerName: this.formModel.customerName
            })
            this.customerList = result.customerList
        }
    }

    async getProjectList() {
        this.projectDialogTableLoading = true


        let obj = {
            marketCooperationId: this.customerInfo.marketCooperationId,
            name: this.dialogProjectInputValue,
            souCourseSchoolBegin: this.handletimeBegin,  //项目开课时间
            page: this.dialogProjectPage,
            limit: this.dialogProjectLimit,
            financeOrderId: this.orderId
        }
        if(!this.orderId) {
            delete obj.financeOrderId
        }
        const data: any = await getProjectList(obj)
        this.projectDialogTableData = data.projectList
        // 初始化 将所有单选框置灰
        this.projectDialogTableData.forEach((item, currentIndex) => {
            this.$set(this.projectDialogTableData[currentIndex], 'disabled', true);
            //将所有的默认值赋为0
            this.$set(this.projectDialogTableData[currentIndex], 'radio', '0');
        })
        /*
        * 1、数据回显
        * 2、判断是否有选中项，有选中则将该条数据放开
        * */
        // 外边选中的
        // this.formModel.project
        this.projectDialogTableData.forEach((item1, index) => {
            if (item1.projectAllId == this.formModel.projectAllId) {
                // debugger
                (this.$refs['dialogProjectTable'] as HTMLFormElement).toggleRowSelection(item1)
                this.$set(this.projectDialogTableData[index], 'radio', this.formModel.isDoubleSouCourseName);
                // 回显
                this.formModel.isDoubleSouCourseName == "0" ? this.$set(this.projectDialogTableData[index], 'radio', '0') : this.$set(this.projectDialogTableData[index], 'radio', '1')
            }
        })

        this.dialogProjectTotal = data.allNum
        this.projectDialogTableLoading = false
        // this.isReadonly = false
    }
    // 选择项目弹框取消
    doCancel(){
        this.projectDialogShow = false
    }

    projectInputFocus() {
        this.dialogProjectPage = 1
        if (this.customerInfo.marketCooperationId === undefined) {
            this.$message.error('请选择客户')
            return
        }
        this.projectDialogShow = true
        this.getProjectList();
        (this.$refs.projectInput as HTMLFormElement).blur()
    }

    dialogProjectRowClick(row) {
        if(!row.flag) return
        (this.$refs.dialogProjectTable as HTMLFormElement).toggleRowSelection(row)
    }

    dialogProjectTableCheckedChange(selection) {
        if(selection.length > 0) {
            this.intentionProjectSelected = selection
            this.projectDialogCheckedTable = JSON.parse(JSON.stringify(selection[0]))
            const dom = this.$refs.dialogProjectTable as HTMLFormElement
            if (selection.length > 1) {
                dom.clearSelection();
                dom.toggleRowSelection(selection.pop());
            }

        } else {
            for(const key in this.projectDialogCheckedTable) {
                this.projectDialogCheckedTable[key] = null
            }
            // this.formModel.project = ''
        //  取消选中 将选中项目也置灰
            this.projectDialogTableData.forEach((item, currentIndex) => {
                this.$set(this.projectDialogTableData[currentIndex], 'disabled', true);
            })
        }
    }
    // 选择意向项目确认
    async clickProjectDialogConfirmButton() {
        if(!this.projectDialogCheckedTable.projectAllId) {
            this.$message.error('请选择项目')
            return
        }
        this.formModel.souTeacherName = this.projectDialogCheckedTable.souTeacherName
        this.formModel.souTeacherSchool = this.projectDialogCheckedTable.souTeacherSchool
        this.formModel.discountAmount = 0
        this.projectDialogShow = false
        if(this.customerInfo.marketCooperationId !== 0) {
            const data: any = await getMarketCooperationCommissionTypeByMarketCooperationIdAndProjectAllId({
                marketCooperationId: this.customerInfo.marketCooperationId,
                projectAllId: this.projectDialogCheckedTable.projectAllId
            })
            this.customerInfo.commissionType = data.commissionType
            if(data.commissionType === '0') {
                const price = this.projectDialogCheckedTable.souCoursePrice.includes('/') ? this.projectDialogCheckedTable.souCoursePrice.split('/')[0] : this.projectDialogCheckedTable.souCoursePrice
                this.formModel.sellingPrice = Number(price) - Number(this.formModel.discountAmount)
            }
            // 终端售价-优惠金额(无结算价)
            if(data.commissionType === '1'){
                this.customerInfo.priceOrRatio = data.priceOrRatio.includes('/') ? data.priceOrRatio.split('/')[0] : data.priceOrRatio
                this.settlementPriceList = data.priceOrRatio.split('/')
                this.formModel.settlementPrice = data.priceOrRatio.includes('/') ? data.priceOrRatio.split('/')[0] : data.priceOrRatio   //结算价
                // settlementPrice 结算价
                    // 订单金额合计 = 结算价、项目终端售价 - 优惠金额
                this.formModel.priceOrRatio = data.priceOrRatio.includes('/') ? data.priceOrRatio.split('/')[0] : data.priceOrRatio
                this.formModel.sellingPrice = Number(this.customerInfo.priceOrRatio) - Number(this.formModel.discountAmount)
            }

            if(data.commissionType === '2') {
                this.formModel.thisRebateRatio = data.priceOrRatio
                this.formModel.priceOrRatio = data.priceOrRatio
                this.customerInfo.priceOrRatio = data.priceOrRatio
                if (this.projectDialogCheckedTable.souCoursePrice.includes('/')) {
                    const a = math.divide(math.bignumber(data.priceOrRatio), 100) as any
                    const b = Number(this.projectDialogCheckedTable.souCoursePrice.split('/')[0] ? this.projectDialogCheckedTable.souCoursePrice.split('/')[0] : 0) as any
                    const c = math.number(math.multiply(b, math.divide(math.bignumber(data.priceOrRatio), 100)))
                    this.customerInfo.ratioPrice = c
                   } else {
                    //项目终端售价*返点 /100 Math.floor
                    const val = Number(this.projectDialogCheckedTable.souCoursePrice) as any
                    const num1 = math.divide(math.bignumber(data.priceOrRatio), 100) as any
                    this.customerInfo.ratioPrice = math.number(math.multiply(math.bignumber(val), math.bignumber(num1)))
                }
            }

        }
        //订单多个价格单选
        this.formModel.teacherUserId = (this as any).projectDialogCheckedTable.teacherUserRealName
        this.formModel.thesisUserId = (this as any).projectDialogCheckedTable.thesisUserRealName
        this.formModel.helperUserId = (this as any).projectDialogCheckedTable.helperUserRealName
        this.formModel.productUserId = (this as any).projectDialogCheckedTable.projectProductUserRealName
        if(this.projectDialogCheckedTable.souCoursePrice.includes('/')){
            this.radioDisable = true
            this.radioOptions = (this.projectDialogCheckedTable.souCoursePrice).split("/")
            this.radioProject = (this.projectDialogCheckedTable.souCoursePrice).split("/")[0]
        }else{
            this.radioDisable = false
            this.radioProject = this.projectDialogCheckedTable.souCoursePrice
        }

        this.projectDialogTableData.forEach(item => {
            if (item.projectAllId == this.projectDialogCheckedTable.projectAllId) {
                if (item.radio == '0') {
                    this.formModel.project = item.souCourseName
                    this.formModel.projectAllId = item.projectAllId
                    this.formModel.souCoursePrice= item.souCoursePrice
                    this.formModel.isDoubleSouCourseName = '0'
                } else {
                    this.formModel.project = item.doubleSouCourseName
                    this.formModel.projectAllId = item.projectAllId
                    this.formModel.souCoursePrice= item.souCoursePrice
                    this.formModel.isDoubleSouCourseName = '1'
                }
            }
        })

        this.sellingPriceComputed()
        this.$forceUpdate()
    }
    handleRadioProject(){
        this.formModel.discountAmount = 0
        this.projectDialogCheckedTable.souCoursePrice = this.radioProject
        // 当结算价有两个及以上的时候才根据选择的项目终端售价进行计算
        if(this.settlementPriceList.length > 1 ) {
            this.customerInfo.priceOrRatio = this.settlementPriceList[this.radioOptions.indexOf(this.radioProject)]
            this.formModel.settlementPrice = this.settlementPriceList[this.radioOptions.indexOf(this.radioProject)]
        }
        // 返点比例切换终端售价
        if(this.customerInfo.commissionType === '2') {
            // 预计返佣金额
            const val = Number(this.radioProject) as any
            let num1 = math.divide(math.bignumber(this.formModel.thisRebateRatio), 100) as any
            this.customerInfo.ratioPrice = math.number(math.multiply(math.bignumber(val),num1))
        }
        this.sellingPriceComputed()
    }
    // 优惠金额改变
    sellingPriceComputed() {
        if(this.customerInfo.marketCooperationId === 0) {
            if(this.projectDialogCheckedTable.souCoursePrice.includes('/')) {
                this.formModel.sellingPrice = Number(this.projectDialogCheckedTable.souCoursePrice.split('/')[0]) - this.formModel.discountAmount
            } else {
                this.formModel.sellingPrice = Number(this.projectDialogCheckedTable.souCoursePrice) - this.formModel.discountAmount
            }
        }

        if(this.customerInfo.marketCooperationId !== 0) {
            if(this.customerInfo.commissionType === '1') {  //结算价
                this.formModel.priceOrRatio = this.customerInfo.priceOrRatio
                this.formModel.sellingPrice = Number(this.customerInfo.priceOrRatio) - Number(this.formModel.discountAmount)
                return
            }
            if(this.customerInfo.commissionType === '2') {  //返点
                if(this.projectDialogCheckedTable.souCoursePrice.includes('/')) {
                    this.formModel.sellingPrice = Number(this.projectDialogCheckedTable.souCoursePrice.split('/')[0]) - this.formModel.discountAmount
                } else {
                    this.formModel.sellingPrice = Number(this.projectDialogCheckedTable.souCoursePrice) - this.formModel.discountAmount
                }
                // 预计返佣金额
                const val = Number(this.formModel.sellingPrice) as any
                let num1 = math.divide(math.bignumber(this.formModel.thisRebateRatio), 100) as any
                this.customerInfo.ratioPrice = math.number(math.multiply(math.bignumber(val), num1))
            }
            if(this.customerInfo.commissionType === '0') {// 终端售价-优惠金额(无结算价)
                const price = this.projectDialogCheckedTable.souCoursePrice.includes('/') ? this.projectDialogCheckedTable.souCoursePrice.split('/')[0] : this.projectDialogCheckedTable.souCoursePrice
                this.formModel.sellingPrice = Number(price) - Number(this.formModel.discountAmount)
            }
        }
    }

    thisRebateRatioChange(val) {
        this.formModel.thisRebateRatio = val
        this.customerInfo.priceOrRatio = val
        if(this.projectDialogCheckedTable.souCoursePrice.includes('/')) {
            const val = Number(this.projectDialogCheckedTable.souCoursePrice.split('/')[0]) as any
            let num1 = math.divide(math.bignumber(this.customerInfo.priceOrRatio ), 100)
            this.customerInfo.ratioPrice = math.number(math.multiply(math.bignumber(val),num1))
        } else {
            const val = Number(this.projectDialogCheckedTable.souCoursePrice) as any
            let num1 = math.divide(math.bignumber(this.customerInfo.priceOrRatio), 100) as any
            this.customerInfo.ratioPrice = math.number(math.multiply(math.bignumber(val), num1))
        }
        this.sellingPriceComputed()
    }

    clickSubmitButton() {

        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if(valid) {
                if(this.radioDisable && !this.radioProject){
                    this.$message.error('请选择项目终端售价')
                    return
                }

                if(!this.formModel.isCredit){
                    this.$message.error('请选择美高学分')
                    return
                }
                if(this.formModel.cooperationUserId && (!this.formModel.achievementRatio && !this.formModel.performanceRatio)){
                    this.$message.error('请填写业绩比例分配')
                    return
                }

                if (this.customerInfo.customerType == 'customerBusiness' && this.formModel.runesName == '') {
                    this.$message.error('请填写送生顾问')
                    return
                }

                if (this.projectDialogCheckedTable.souCourseType=='企业导师远程实训' && this.formModel.scene == '') {
                    this.$message.error('请填写企业导师推荐信使用场景')
                    return
                }

                const achievementRatio = this.formModel.achievementRatio + ':' + this.formModel.performanceRatio


                if(this.orderId) {
                    const obj = {
                        id: this.orderId,
                        projectAllId: this.formModel.projectAllId,
                        souCoursePrice: this.radioProject?this.removeSpaces(this.radioProject):'', // 项目终端售价
                        commissionType: this.customerInfo.commissionType ? this.customerInfo.commissionType : '0',
                        priceOrRatio: this.customerInfo.priceOrRatio ? String(this.removeSpaces(this.customerInfo.priceOrRatio)) : '', // 结算价或返点比例
                        discountPrice: this.removeSpaces(this.formModel.discountAmount), // 优惠金额
                        haveIPQ: this.formModel.isIPQ,
                        dissertationType: this.formModel.dissertationType,
                        remark: this.formModel.remark,
                        adviser: this.formModel.runesName,
                        directorUserId: this.formModel.directorUserId,
                        cooperationUserId: this.formModel.cooperationUserId,
                        achievementRatio:this.formModel.cooperationUserId?achievementRatio: null,
                        isCredit: this.formModel.isCredit,
                        projectDissertationId: this.customerInfo.marketCooperationId,
                        price: this.formModel.sellingPrice || this.formModel.sellingPrice == 0 ? String(this.removeSpaces(this.formModel.sellingPrice)) : '', // 订单金额合计
                        isDoubleSouCourseName:this.formModel.isDoubleSouCourseName,
                        companyName: this.formModel.companyName,
                        contractNo: this.formModel.contractNo,
                        egistrationForm: this.formModel.egistrationForm,
                        ipqSubject: this.formModel.ipqSubject,
                        scene: this.formModel.scene
                    }
                    const newData = delNullProperty(obj)
                    newData.egistrationForm = this.formModel.egistrationForm
                    this.disabledButton = true
                    setFinanceOrderById(newData).then(() => {
                        this.$message.success('编辑订单成功，页面即将关闭')
                        setTimeout(() => {
                            window.close()
                        }, 1500)
                    }).catch((err: Error) => {
                        if (err) {
                            this.disabledButton = false
                        }
                        if(err.message === '审批流报错') {
                            this.errorDialogShow = true
                        }

                    })
                } else {

                    // 订单金额合计 = 结算价、项目终端售价 - 优惠金额
                    let price = String(this.formModel.sellingPrice)
                    if(this.customerInfo.commissionType == '1'){   //结算价
                        price = String(Number(this.formModel.settlementPrice) - Number(this.formModel.discountAmount))
                    } else {
                        price = String(Number(this.radioProject) - Number(this.formModel.discountAmount))
                    }
                    this.formModel.sellingPrice = Number(price)

                    const obj = {
                        customerId: this.customerInfo.customerId,
                        customerType: this.customerInfo.customerType,
                        sourceType: this.customerInfo.customerSourceType == '普通来源' ? '0' : '1',
                        source: this.customerInfo.customerSource,
                        // projectAllId: this.projectDialogCheckedTable.projectAllId,
                        projectAllId: this.formModel.projectAllId,
                        souCoursePrice: this.radioProject?this.removeSpaces(this.radioProject):'', // 项目终端售价
                        commissionType: this.customerInfo.commissionType ? this.customerInfo.commissionType : '0',
                        priceOrRatio: this.customerInfo.priceOrRatio ? String(this.removeSpaces(this.customerInfo.priceOrRatio)) : '', // 结算价或返点比例 可选值
                        discountPrice:this.removeSpaces(this.formModel.discountAmount), // 优惠金额
                        haveIPQ: this.formModel.isIPQ,
                        dissertationType: this.formModel.dissertationType,
                        remark: this.formModel.remark,
                        createdUserId: this.userId,
                        adviser: this.formModel.runesName,
                        directorUserId: this.formModel.directorUserId,
                        cooperationUserId: this.formModel.cooperationUserId,
                        achievementRatio: this.formModel.cooperationUserId?achievementRatio:null,
                        isCredit: this.formModel.isCredit,
                        isDraft: this.isDraft,
                        price: this.removeSpaces(price), // 订单金额合计
                        // price: this.formModel.sellingPrice || this.formModel.sellingPrice == 0 ? String(this.formModel.sellingPrice) : '',
                        marketCooperationId: this.customerInfo.marketCooperationId,
                        isDissertation: '0',
                        isDoubleSouCourseName: this.formModel.isDoubleSouCourseName,
                        companyName: this.formModel.companyName,
                        contractNo: this.formModel.contractNo,
                        egistrationForm: this.formModel.egistrationForm,
                        ipqSubject: this.formModel.ipqSubject,
                        scene: this.formModel.scene,
                    }
                    this.disabledButton = true
                    setFinanceOrder(delNullProperty(obj)).then(() => {
                        this.$message.success(this.isDraft === '0' ? '新建订单成功，页面即将关闭' : '订单已保存到草稿箱')
                        setTimeout(() => {
                            window.close()
                        }, 1500)
                    }).catch((err: Error) => {
                        if (err) {
                            this.disabledButton = false
                        }
                        // 没有查到相关审批流程，暂时无法新建订单，请联系管理员设置审批流程
                        if(err.message === '审批流报错') {
                            this.errorDialogShow = true
                        }
                    })
                }
            }
        })
    }

    /*
    *去空格 */
    removeSpaces(str) {
        if (typeof (str) == "number") {
            str = String(str)
        }
        let str1 = String(str).trim()
        return str1.replace(/\s+/g, "");
    }

    closePage() {
        window.close()
    }

    clickSaveDraftButton() {
        // TODO 点击存草稿按钮
        this.saveDraftDialogShow = true
    }

    saveDraftDialogConfirm() {
        this.isDraft = '1'
        this.clickSubmitButton()
        this.saveDraftDialogShow = false
    }

    saveDraftDialogCancel() {
        this.isDraft = '0'
        this.saveDraftDialogShow = false
    }

    projectPageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.dialogProjectPage = page
            this.getProjectList()
        }, 1000)
    }
    projectLimitChange(limit: number) {
        this.dialogProjectLimit = limit
        this.getProjectList()
    }
    handleCompanyList(val){
        // console.log(val,'form-',this.formModel.companyName)
    }

    directorUserIdChange() {
        if(this.formModel.directorUserId === '1')  return
        getDepartmentByUserId(this.formModel.directorUserId).then((res: any) => {
            this.formModel.department = res.departmentName
        })
    }
    handleRatio(val){
        val = this.handleOninput(val)
        this.formModel.achievementRatio = val
        // this.orderAllNum = 10 - Number(this.formModel.achievementRatio)
    }
    handlePerformanceRatio(val){
        val = this.handleOninput(val)
        this.formModel.performanceRatio = val
    }
    handleOninput(num) {
        var str = num
        var len1 = str.substr(0, 1)
        var len2 = str.substr(1, 1)
        //如果第一位是0，第二位不是点，就用数字把点替换掉
        if (str.length > 1 && len1 == 0 && len2 != ".") {
            str = str.substr(1, 1)
        }
        //第一位不能是.
        if (len1 == ".") {
            str = ""
        }
        //限制只能输入一个小数点
        if (str.indexOf(".") != -1) {
            var str_ = str.substr(str.indexOf(".") + 1)
            if (str_.indexOf(".") != -1) {
            str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1)
            }
        }
        //正则替换
        str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
        // if (limit / 1 === 1) {
        //     str = str.replace(/^\D*([0-9]\d*\.?\d{0,1})?.*$/,'$1') // 小数点后只能输 1 位
        // } else {
        //     str = str.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1') // 小数点后只能输 2 位
        // }
        return str
    }

    // 合作成单同事
    cooperationUserIdChange() {
        if(!this.formModel.cooperationUserId){
            this.isPatioShow = false
        }else {
            this.isPatioShow = true
        }

        if(this.formModel.cooperationUserId === '1')  return
    }

    clickEditSaveButton(type: '0' | '1') {
        let achievementRatio = this.formModel.achievementRatio + ':' + this.formModel.performanceRatio
        if(this.formModel.cooperationUserId && (!this.formModel.achievementRatio && !this.formModel.performanceRatio) ){
            this.$message.error('请填写业绩比例分配')
            return
        }

        const obj = {
            customerId: this.customerInfo.customerId,
            customerType: this.customerInfo.customerType,
            sourceType: this.customerInfo.customerSourceType == '普通来源' ? '0' : '1',
            source: this.customerInfo.customerSource,
            // projectAllId: this.projectDialogCheckedTable.projectAllId,
            projectAllId: this.formModel.projectAllId,
            // souCoursePrice: this.projectDialogCheckedTable.souCoursePrice,
            souCoursePrice: this.removeSpaces(this.formModel.souCoursePrice),
            commissionType: this.customerInfo.commissionType ? this.customerInfo.commissionType : '0',
            priceOrRatio: this.customerInfo.priceOrRatio ? String(this.removeSpaces(this.customerInfo.priceOrRatio)) : '',
            discountPrice: this.removeSpaces(this.formModel.discountAmount),
            haveIPQ: this.formModel.isIPQ,
            remark: this.formModel.remark,
            adviser: this.formModel.runesName,
            directorUserId: this.formModel.directorUserId,
            cooperationUserId: this.formModel.cooperationUserId,
            achievementRatio: this.formModel.cooperationUserId?achievementRatio:null,
            isDraft: this.isDraft,
            price: this.formModel.sellingPrice || this.formModel.sellingPrice == 0 ? String(this.removeSpaces(this.formModel.sellingPrice)) : '',
            marketCooperationId: this.customerInfo.marketCooperationId,
            isDissertation: '0',
            dissertationType: this.formModel.dissertationType,  //论文服务类型
            isCredit: this.formModel.isCredit,  //美高学分
            companyName: this.formModel.companyName, //所属公司
            contractNo: this.formModel.contractNo,
            ipqSubject: this.formModel.ipqSubject,
            scene: this.formModel.scene,
        }
        const newData = delNullProperty({id: this.draftId, form: obj, isSubmit: type})
        newData.form.egistrationForm = this.formModel.egistrationForm
        this.disabledButton = true
        setDraftById(newData).then(() => {
            if (type === '0') {
                this.$message.success('草稿编辑成功，页面即将关闭')
            } else {
                this.$message.success('草稿提交成功，页面即将关闭')
            }
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            if(type === '1') {
                if(err.message === '审批流报错') {
                    this.errorDialogShow = true
                }
            }
            this.disabledButton = false
        })
    }

    selectable(row) {
        return row.flag
    }
    changeFile(file, fileList) {
        if (fileList.length > 1) {
            fileList.splice(0, 1);
        }
        this.fileList = fileList;
        if(file.response){
            this.formModel.egistrationForm = file.response.data.ossUrl
        }
    }
    async handleUploadSuccess(res, file, fileList) {
        if (res.error.returnCode !== 0) {
            this.$message.error(`上传失败，${res.error.returnMessage}`)
            return
        }
        this.$message.success('上传成功')
        const obj = { name: file.name, url: res.data.ossUrl }
        this.fileList.push(obj)
        this.formModel.egistrationForm = this.fileList[0].url
    }
    async handleUploadError() {
        this.$message.error('上传失败')
    }

    async handleUploadRemove(file, fileList) {
        this.fileList = fileList
        this.formModel.egistrationForm = ''
    }

    @Watch('userId')
    handleUserIdChange() {
        if(!this.formModel.directorUserId) {
            this.formModel.directorUserId = this.userId
            this.directorUserIdChange()
        }
    }

    @Watch('userId')
    handleCooperationChange() {
        if(!this.formModel.cooperationUserId) {
            // this.formModel.cooperationUserId = this.userId
            // this.cooperationUserIdChange()
        }
    }


    // @Watch('formModel.sellingPrice', { deep: true })
    // handleSellingPriceChange(newVal) {
    //     // 在金额改变的时候将 changeData  变为 true
    //     if(newVal != this.oldFormData.price) {
    //         this.changeData = true
    //     } else {
    //         this.changeData = false
    //     }
    // }

    // @Watch('projectDialogCheckedTable', { deep: true })
    // handleProjectChange(newVal) {
    //     if(this.oldFormData.projectAllId != newVal.projectAllId) {
    //         this.changeData = true
    //     } else {
    //         this.changeData = false
    //     }
    // }

    @Watch('intentionProjectSelected', {deep: true})
    handleChangeDisabled(val, oVal) {
        if (val !== oVal) {
            // 选中当前行 将当前行的disable属性置灰
            this.projectDialogTableData.forEach((item, currentIndex) => {
                item.disabled = true
                val.forEach(i => {
                    if (item.projectAllId !== i.projectAllId) {
                        this.$set(this.projectDialogTableData[currentIndex], 'radio', '0');
                    }
                })
            })
            val[0].disabled = false
        }
    }

}
